import user from './user/user'
import babyapi from './baby/babyapi'
import printer from './device/printer'
import ota from './device/otaapi'
import auth from './device/auth'
import role from './user/role'
import bi from './bi/bi'
import aws from './aws/aws'
import mapString from './mapString'
import banner from "./banner";
import deviceCode from "./device/deviceCode";
import mask from "./mask"
import answer from "./answer"
import translation from "./translation/translation"
import device from "./baby/device"

const api = {
  ...user,
  ...babyapi,
  ...printer,
  ...ota,
  ...auth,
  ...role,
  ...bi,
  ...aws,
  ...mapString,
  ...banner,
  ...deviceCode,
  ...mask,
  ...answer,
  ...translation,
  ...device
}

export default (Vue) => {
  Vue.api = Vue.prototype.$api = api
}



// WEBPACK FOOTER //
// ./src/api/all.js